const CacheBustPlugin = () => {
  return {
    name: 'cache-bust-plugin',
    beforeRequest: args => {
      const { options, id } = args;
      const remoteName = id.split('/').shift();
      const remote = options.remotes.find(remote => remote.name === remoteName);
      // Guard against undefined remote
      if (!remote) {
        return args;
      }
      
      if (remote.entry.includes('?v=')) {
        return args;
      }
      remote.entry = `${remote.entry}?v=${Date.now()}`;
      return args;
    },
  };
};

export default CacheBustPlugin;
